module.exports = __webpack_public_path__ + "assets/img/82473e03083f7d64d39a9de0ecad2372.svg";